
























import { Component, Vue, Model, Watch, Prop } from 'vue-property-decorator';

export interface InputFile {
    filename: string;
    data: string;
}

const getBase64 = async (file: File) => {
    return new Promise<string>(res => {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            if (typeof reader.result === 'string') {
                res(reader.result);
            }
        });
        reader.readAsDataURL(file);
    });
};

@Component({})
export default class UploadComponent extends Vue {
    @Model('value') readonly value!: InputFile | null;
    @Prop({ default: 'Choisir un fichier...' }) placeholder!: string;
    @Prop({ type: Boolean, default: false }) loading!: boolean;
    @Prop({ default: '*' }) accept!: string;
    pValue: InputFile | null = null;

    @Watch('value', { deep: true, immediate: true })
    onValue() {
        this.pValue = this.value;
    }

    selectFile() {
        if (this.loading) {
            return;
        }

        const $input = this.$refs.input as HTMLInputElement;

        if (!$input) {
            return;
        }

        $input.click();
    }

    deleteFile() {
        if (this.loading) {
            return;
        }

        this.$emit('delete');
    }

    async fileChangeListener(ev: Event, type: string) {
        const target = ev.target as HTMLInputElement;

        if (!target.files) {
            return;
        }
        const file: File = target.files[0];

        const uploadFile: InputFile = {
            filename: file.name,
            data: await getBase64(file),
        };

        this.pValue = uploadFile;
        this.$emit('value', uploadFile);
        this.$emit('change', uploadFile);
    }

    reset() {
        this.pValue = null;
        this.$emit('value', null);
    }
}
